import Splide from '@splidejs/splide';

export default class HeaderSlider {
    private static readonly SLIDER_SELECTOR = '.js-header-slider';
    private static readonly PROGRESS_BUTTON_SELECTOR = '.header-slider__pagination button';
    private static readonly PROGRESS_FILL_PROPERTY = '--header-slider-fill';
    private static readonly PROGRESS_TRANSITION_PROPERTY = '--header-slider-transition';
    private static readonly SLIDE_SPEED = 500;
    private static readonly PROGRESS_DURATION = 2500;
    private static readonly AUTOPLAY_INTERVAL = 3500;

    static init(): void {
        const sliders = document.querySelectorAll<HTMLElement>(this.SLIDER_SELECTOR);

        if (sliders.length === 0) return;

        sliders.forEach((sliderElement) => {
            this.initializeSlider(sliderElement);
        });
    }

    private static initializeSlider(sliderElement: HTMLElement): void {
        const slider = new Splide(sliderElement, {
            perPage: 1,
            speed: this.SLIDE_SPEED,
            autoplay: true,
            interval: this.AUTOPLAY_INTERVAL - this.SLIDE_SPEED,
            arrows: false,
            type: 'fade',
            pagination: true,
            drag: false,
            rewind: true,
            pauseOnHover: false
        });

        slider.mount();

        setTimeout(() => {
            const buttons = sliderElement.querySelectorAll<HTMLButtonElement>(this.PROGRESS_BUTTON_SELECTOR);
            this.initializeProgress(buttons);
            this.setupProgressAnimation(slider, buttons);
        }, this.SLIDE_SPEED);
    }

    private static initializeProgress(buttons: NodeListOf<HTMLButtonElement>): void {
        buttons.forEach((button, index) => {
            button.style.setProperty(this.PROGRESS_TRANSITION_PROPERTY, 'none');
            button.style.setProperty(this.PROGRESS_FILL_PROPERTY, '0');

            if (index === 0) {
                button.style.setProperty(this.PROGRESS_TRANSITION_PROPERTY, `transform ${this.PROGRESS_DURATION}ms linear`);
                button.style.setProperty(this.PROGRESS_FILL_PROPERTY, '1');
            }
        });
    }

    private static setupProgressAnimation(
        slider: any,
        buttons: NodeListOf<HTMLButtonElement>
    ): void {
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                btn.classList.add('is-manual');
            });
        });

        slider.on('moved', () => {
            buttons.forEach((btn, index) => {
                btn.style.setProperty(this.PROGRESS_TRANSITION_PROPERTY, `none`);
                btn.style.setProperty(this.PROGRESS_FILL_PROPERTY, '0');

                if (index === slider.index) {
                    if (btn.classList.contains('is-manual')) {
                        btn.style.setProperty(this.PROGRESS_FILL_PROPERTY, '1');
                        btn.classList.remove('is-manual');
                    } else {
                        setTimeout(() => {
                            btn.style.setProperty(this.PROGRESS_TRANSITION_PROPERTY, `transform ${this.PROGRESS_DURATION}ms linear`);
                            btn.style.setProperty(this.PROGRESS_FILL_PROPERTY, '1');
                        }, this.SLIDE_SPEED + 10);
                    }
                }
            });
        });
    }
}
